<section class="content tab-section d-flex">
  <div class="content-block flex-grow-1">
    <div class="tab-content flex-grow-1 d-flex flex-wrap flex-md-nowrap">
      <div class="tab-c">
        <div *ngFor="let item of settingsArr" class="set-tab"
          [ngClass]="item.name==selectedSetting.name ? 'active-sett' :''" (click)="onSelectedSettings(item)">
          {{item.name}}</div>
      </div>
      <div class="flex-grow-1  ps-md-4">
        <div *ngIf="selectedSetting.id==0">
          <h3>Manage Legal Compliance</h3>
          <form [formGroup]="visaForm" (ngSubmit)="onSubmitVisa()">
            <div class="mt-4">
              <label for="">Default Hours</label>
              <div class="form-input">
                <!-- <mat-icon class="kt-margin-r-0 euro">euro_symbol</mat-icon> -->
                <input type="number" class="form-control in" placeholder="Enter Hours" formControlName="d_h" />
                <mat-error
                  *ngIf="visaForm.get('d_h')?.hasError('required') && visaForm.get('d_h')?.touched">{{"COMMON.THR" |
                  translate }}</mat-error>
              </div>
              <div>
                <!-- <mat-error *ngIf="isControlHasError('pr', 'required')"> {{ "This is required" | translate}}</mat-error> -->
              </div>
              <div class="note-sm-txt mt-1">
                <span class="text-bold">Note:</span>
                <div>
                  The hours specified here will be the default for all employees. However, you can adjust the hours for
                  individual employees if necessary.
                </div>
              </div>
            </div>
            <div class="mt-3" formArrayName="dates">
              <label for="">Dates</label>
              <div class="row close-box" *ngFor="let item of visaDates.controls;let i=index" [formGroupName]="i">
                <div class="close-ic" (click)="onDeleteItem(i)" *ngIf="i!==0">
                  <i class="material-icons">close</i>
                </div>
                <div class=" col-sm-7 col-md-8  mb-3">
                  <div class="d-flex  flex-wrap">
                    <div class="in-box me-4 flex-grow-1 mt-1">
                      <input class="form-control" [matDatepicker]="sDate" placeholder="Select Start Date"
                        formControlName="st_dt" />
                      <mat-datepicker-toggle matIconSuffix [for]="sDate"></mat-datepicker-toggle>
                      <mat-datepicker #sDate></mat-datepicker>
                    </div>
                    <div class="in-box flex-grow-1 mt-1">
                      <input class="form-control" [matDatepicker]="eDate" placeholder="Select End Date"
                        formControlName="ed_dt" />
                      <mat-datepicker-toggle matIconSuffix [for]="eDate"></mat-datepicker-toggle>
                      <mat-datepicker #eDate></mat-datepicker>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5 col-md-4 mb-3  d-flex  align-items-center ">
                  <input type="number" class="form-control num-b" placeholder="Permitted Hour"
                    formControlName="permitted_hour">
                  <div class="action-icon  del-icon delete-img ms-2" (click)="removeVisaDates(i)">
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </div>
              <div class="i-box cursor-pointer mt-3 mt-sm-0">
                <span (click)="addVisaDates()"><i class="fas fa-plus"></i>Add New Date</span>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-6 m-auto">
                <button mat-raised-button color="primary" class="auth-form-btn mt-4" type="submit">{{"BUTTON.SAVE" | translate }}</button>
              </div>
            </div> -->
          </form>
          <h3 class="mt-4">Rules for Young Workers</h3>
          <form [formGroup]="youngVisaForm" (ngSubmit)="onSubmitYoungVisa()" class="">
            <div class="mt-4">
              <div class="row">
                <div class="col-md-6">
                  <label for="">Default Hours(per week)</label>
                  <div class="form-input">
                    <input type="number" class="form-control in" placeholder="Enter Hours" formControlName="d_h" />
                  </div>
                  <mat-error *ngIf="isControlHasError('d_h','required')">{{"COMMON.THR" | translate }}</mat-error>
                  <div>
                    <mat-error
                      *ngIf="isControlHasError('d_h','nonPositiveValidator')  && youngVisaForm.get('d_h')?.value">
                      {{"VALIDATION.GTZ"|translate}} </mat-error>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="">Default Age (Young Worker)</label>
                  <div class="form-input">
                    <input type="number" class="form-control in" placeholder="Enter Age" formControlName="age" />
                  </div>
                  <mat-error *ngIf="isControlHasError('age','required')">{{"COMMON.THR" | translate }}</mat-error>
                  <div>
                    <mat-error
                      *ngIf="isControlHasError('age','nonPositiveValidator') && youngVisaForm.get('age')?.value">
                      {{"VALIDATION.GTZ"|translate}} </mat-error>
                  </div>
                </div>
              </div>
              <div class="note-sm-txt mt-1">
                <span class="text-bold">Note:</span>
                <div>
                  1. The hours specified here will be the default for all employees. However, you can adjust the hours
                  for individual employees if necessary.
                </div>
                <div>
                  2. Start time here means the time before which a young worker can't work
                </div>
                <div>
                  3. End time means the time after which a young worker can't work.
                </div>
              </div>
            </div>
            <div class="mt-3 sett-box" formArrayName="dates">
              <label for="">Dates</label>
              <div class="row close-box" *ngFor="let date of youngVisaDates.controls; let i = index"
                [formGroupName]="i">
                <div class="close-ic" (click)="onDeleteItem(i)" *ngIf="i!==0">
                  <i class="material-icons">close</i>
                </div>
                <div class="col-12">
                  <div class="yw-box ">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-center  flex-wrap">
                        <div>
                          <label for="" class="mt-3 mb-1">Start Date</label>
                          <div class="in-box me-3">
                            <input class="form-control" [matDatepicker]="sDate" placeholder="Select Start Date"
                              formControlName="st_dt" />
                            <mat-datepicker-toggle matIconSuffix [for]="sDate"></mat-datepicker-toggle>
                            <mat-datepicker #sDate></mat-datepicker>
                            <mat-error
                              *ngIf="date.get('st_dt')?.hasError('required') && date.get('st_dt')?.touched">{{"COMMON.THR"|translate}}</mat-error>
                          </div>
                        </div>
                        <div>
                          <label for="" class="mt-3 mb-1">End Date</label>
                          <div class="in-box me-3">
                            <input class="form-control" [matDatepicker]="eDate" placeholder="Select End Date"
                              formControlName="ed_dt" />
                            <mat-datepicker-toggle matIconSuffix [for]="eDate"></mat-datepicker-toggle>
                            <mat-datepicker #eDate></mat-datepicker>
                            <mat-error
                              *ngIf="date.get('ed_dt')?.hasError('required') && date.get('ed_dt')?.touched">{{"COMMON.THR"|translate}}</mat-error>
                          </div>
                        </div>
                        <div>
                          <label for="" class="mt-3 mb-1">Permitted Hour</label>
                          <input type="number" class="form-control num-b me-3" placeholder="Permitted Hour"
                            formControlName="permitted_hour">
                          <mat-error
                            *ngIf="date.get('permitted_hour')?.hasError('required') && date.get('permitted_hour')?.touched">{{"COMMON.THR"|translate}}</mat-error>
                          <div>
                            <mat-error *ngIf="date.get('permitted_hour')?.hasError('nonPositiveValidator') && date.get('permitted_hour')?.touched && 
                              date.get('permitted_hour')?.value"> {{"VALIDATION.GTZ"|translate}} </mat-error>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-wrap">
                        <div>
                          <label for="" class="mt-3 mb-1">Start Time</label>
                          <input [ngxTimepicker]="picker" [format]="24" class="form-control num-b me-3"
                            placeholder="Select Start Time" formControlName="st_ti">
                          <ngx-material-timepicker #picker></ngx-material-timepicker>
                          <mat-error *ngIf="date.get('st_ti')?.hasError('required') && date.get('ed_dt')?.touched">
                            {{"COMMON.THR"|translate}}</mat-error>
                        </div>
                        <div>
                          <label for="" class="mt-3 mb-1">End Time</label>
                          <input [ngxTimepicker]="epicker" [format]="24" class="form-control num-b  me-3"
                            placeholder="Select End Time" formControlName="ed_ti">
                          <ngx-material-timepicker #epicker></ngx-material-timepicker>
                          <mat-error *ngIf="date.get('ed_ti')?.hasError('required') && date.get('ed_ti')?.touched">
                            {{"COMMON.THR"|translate}}</mat-error>
                        </div>
                      </div>
                    </div>
                    <div class="action-icon  del-icon delete-img ms-2 flex-shrink-0" (click)="removeDates(i)">
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </div>
                <!-- <div class=" col-sm-7 col-md-8  mb-3 ">
                  <div class="d-flex  flex-wrap">
                    <div class="in-box flex-grow-1 mt-1">
                      <input class="form-control" [matDatepicker]="sDate" placeholder="Select Start Date" />
                      <mat-datepicker-toggle matIconSuffix [for]="sDate"></mat-datepicker-toggle>
                      <mat-datepicker #sDate></mat-datepicker>
                    </div>
                    <div class="in-box flex-grow-1 mt-1">
                      <input class="form-control" [matDatepicker]="eDate" placeholder="Select End Date" />
                      <mat-datepicker-toggle matIconSuffix [for]="eDate"></mat-datepicker-toggle>
                      <mat-datepicker #eDate></mat-datepicker>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5 col-md-4 mb-3  d-flex  align-items-center ">
                  <input type="number" class="form-control num-b" placeholder="Permitted Hour" [(ngModel)]="item.d_h"
                    [ngModelOptions]="{standalone: true}">
                  <div class="action-icon  del-icon delete-img ms-2" (click)="onDeleteItem(i)">
                    <i class="material-icons">close</i>
                  </div>
                </div> -->
              </div>
              <div class="i-box cursor-pointer mt-3">
                <span (click)="addYoungVisaDates()"><i class="fas fa-plus"></i> Add New Dates</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 m-auto">
                <button mat-raised-button color="primary" class="auth-form-btn mt-4" type="submit">{{"Save" |
                  translate}}</button>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="selectedSetting.id==2 || selectedSetting.id==3">
          <h4 *ngIf="selectedSetting.id==2">Company Default Invoicing Rates</h4>
          <h4 *ngIf="selectedSetting.id==3">Employee Default Invoicing Rates</h4>
          <div class="d-flex justify-content-between  user-b mb-1 flex-wrap">
            <div class="search-cont mt-3 mt-sm-4">
              <div class="s-in form-input" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
                  (input)="onSearch($event)" />
              </div>
            </div>
            <button mat-raised-button color="primary" class="primary-btn mt-2 mt-md-4 mb-sm-2 mb-md-0" type="submit"
              (click)="onAddEditCat('','')"><i class="fas fa-plus"></i> Add New </button>
          </div>
          <div class="table-container mt-4 flex-grow-1 ">
            <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              <!-- <table class="" mat-table [dataSource]="dataSource" 
                          class="mat-elevation-z8"  *ngIf="dataSource.data.length!=0"> -->
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef>
                  {{"Category Name"|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.j_c }} </td>
              </ng-container>
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>
                  {{"Created At"|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.c_at | dates:'date_time'}} </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <!-- <div class="action-btn me-2" matTooltip="View" (click)="onViewCompanyRates()">
                      <img src="assets/images/icons/view_icon.svg" class="img-fluid" alt="">
                    </div> -->
                    <div class="action-btn me-2" matTooltip="Edit" (click)="onAddEditCat('edit',element)">
                      <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-btn  cursor-pointer" matTooltip="Delete"
                      (click)="onDeleteCompanyRate(element.id)">
                      <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dataSource.data.length==0">
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
          </div>
          <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
            <div class="show-item">
              {{"COMMON.SIP" | translate}}
              <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                [(ngModel)]="config.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions">
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="page-c">
              <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column gap-4 align-items-center" *ngIf="selectedSetting.id==4">

          <div class="first-main-div first-main-div-2">
            <div class="time-off-settings">
              <div class="section">
                <div class="title "> Overtime setting
                </div>
                <div>Select the overtime rules that best fits your business needs</div>
                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle color="primary"
                      [(ngModel)]="generalObj.weekly_overtime.selected"></mat-slide-toggle> Weekly overtime
                  </div>
                  <div class="border-b"> </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" class="form-control" [(ngModel)]="generalObj.weekly_overtime.value"
                          [disabled]="generalObj.weekly_overtime.selected==false"> Hours/week
                      </span>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">
                        {{ generalObj.weekly_overtime.s_m == 1 ? 'Multiplier' : 'Additional' }}
                        <input type="number" class="form-control" [(ngModel)]="generalObj.weekly_overtime.s_mv"
                          [disabled]="generalObj.weekly_overtime.selected==false">
                        <mat-select [(ngModel)]="generalObj.weekly_overtime.s_m" class="sel-w ms-2" panelClass="sel-we"
                          [disabled]="generalObj.weekly_overtime.selected==false">
                          <mat-option [value]="1" selected>X base wage</mat-option>
                          <mat-option [value]="2">+ base wage</mat-option>
                        </mat-select>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle color="primary"
                      [(ngModel)]="generalObj.daily_overtime.selected"></mat-slide-toggle>
                    Daily overtime
                  </div>
                  <div class="border-b"> </div>
                  <div class="d-flex gap-2">
                    <div class="d-flex align-items-center">on days :</div>
                    <div class="day-buttons">
                      <button *ngFor="let day of workdays"
                        [ngClass]="{ selected: getSelectedDays('daily_overtime',day.value) }"
                        (click)="onAddDaysOvertime('daily_overtime',day)">{{ day.label }} </button>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" class="form-control" [(ngModel)]="generalObj.daily_overtime.value">
                        Hours</span>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2"> {{ generalObj.daily_overtime.s_m == 1 ?
                        'Multiplier'
                        : 'Additional' }}
                        <input type="number" class="form-control" [(ngModel)]="generalObj.daily_overtime.s_mv">
                        <mat-select [(ngModel)]="generalObj.daily_overtime.s_m" class="sel-w ms-2" panelClass="sel-we">
                          <mat-option [value]="1" selected>X base wage</mat-option>
                          <mat-option [value]="2">+ base wage</mat-option>
                        </mat-select>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle color="primary" [(ngModel)]="generalObj.premium_time.selected"></mat-slide-toggle>
                    Premium time
                  </div>
                  <div class="border-b"> </div>
                  <div class="d-flex gap-2">
                    <div class="d-flex align-items-center">on days :</div>
                    <div class="day-buttons">
                      <button *ngFor="let day of workdays"
                        [ngClass]="{ selected: getSelectedDays('premium_time',day.value) }"
                        (click)="onAddDaysOvertime('premium_time',day)">{{ day.label }} </button>
                    </div>
                  </div>
                  <!-- <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" [(ngModel)]="generalObj.premium_time.value" class="form-control">
                        Hours</span>
                    </div>
                  </div> -->
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Default
                        <input type="number" [(ngModel)]="generalObj.premium_time.value" class="form-control">
                        Hours</span>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2"> Custom
                        <input type="number" class="form-control" [(ngModel)]="generalObj.premium_time.s_mv">
                      </span>
                    </div>
                  </div>
                </div>

                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle color="primary"
                      [(ngModel)]="generalObj.night_premium.selected"></mat-slide-toggle>Night Premium
                  </div>
                  <div class="border-b"> </div>

                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Between
                        <input type="number" [(ngModel)]="generalObj.night_premium.fr" class="form-control">
                        To <input type="number" [(ngModel)]="generalObj.night_premium.to" class="form-control"></span>
                      <!-- <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" [(ngModel)]="generalObj.night_premium.value" class="form-control">
                        Hours/week</span> -->
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2"> {{ generalObj.night_premium.s_m == 1 ? 'Multiplier'
                        : 'Additional' }}
                        <input type="number" class="form-control" [(ngModel)]="generalObj.night_premium.s_mv">
                        <mat-select class="sel-w ms-2" panelClass="sel-we" [(ngModel)]="generalObj.night_premium.s_m">
                          <mat-option [value]="1" selected>X base wage</mat-option>
                          <mat-option [value]="2">+ base wage</mat-option>
                        </mat-select>
                      </span>
                    </div>
                  </div>
                </div>



                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle [(ngModel)]="generalObj.partial_day_overtime.selected"
                      color="primary"></mat-slide-toggle> Partial day overtime
                  </div>
                  <div class="border-b"> </div>
                  <div class="d-flex gap-2">
                    <div class="d-flex align-items-center">on days :</div>
                    <div class="day-buttons">
                      <button *ngFor="let day of workdays"
                        [ngClass]="{ selected: getSelectedDays('partial_day_overtime',day.value) }"
                        (click)="onAddDaysOvertime('partial_day_overtime',day)"> {{ day.label }} </button>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.fr">
                        Hours <input type="number" class="form-control"
                          [(ngModel)]="generalObj.partial_day_overtime.to"></span>
                      <!-- <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.value">
                        Hours</span> -->
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2"> {{ generalObj.partial_day_overtime.s_m == 1 ?
                        'Multiplier' : 'Additional' }}
                        <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.s_mv">
                        <mat-select [(ngModel)]="generalObj.partial_day_overtime.s_m" class="sel-w ms-2"
                          panelClass="sel-we">
                          <mat-option [value]="1" selected>X base wage</mat-option>
                          <mat-option [value]="2">+ base wage</mat-option>
                        </mat-select>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle color="primary"
                      [(ngModel)]="generalObj.consecutive_days_overtime.selected"></mat-slide-toggle>
                    Consecutive day overtime
                  </div>
                  <div class="border-b"> </div>
                  <div class="d-flex gap-2">
                    <div class="d-flex align-items-center">on days :</div>
                    <div class="day-buttons">
                      <button *ngFor="let day of workdays"
                        [ngClass]="{ selected: getSelectedDays('consecutive_days_overtime',day.value) }"
                        (click)="onAddDaysOvertime('consecutive_days_overtime',day)"> {{ day.label }} </button>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start on the
                        <input type="number" class="form-control"
                          [(ngModel)]="generalObj.consecutive_days_overtime.st_on"> Consecutive day</span>

                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" class="form-control"
                          [(ngModel)]="generalObj.consecutive_days_overtime.value"> Hours</span>
                    </div>
                  </div>

                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">
                        {{ generalObj.consecutive_days_overtime.s_m ==1 ? 'Multiplier' : 'Additional' }}
                        <input type="number" class="form-control"
                          [(ngModel)]="generalObj.consecutive_days_overtime.s_mv">
                        <mat-select [(ngModel)]="generalObj.consecutive_days_overtime.s_m" class="sel-w ms-2"
                          panelClass="sel-we">
                          <mat-option [value]="1" selected>X base wage</mat-option>
                          <mat-option [value]="2">+ base wage</mat-option>
                        </mat-select>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="g-card flex-column gap-3 mt-3">
                  <div class="title d-flex align-items-center gap-1">
                    <mat-slide-toggle color="primary"
                      [(ngModel)]="generalObj.pay_period_overtime.selected"></mat-slide-toggle>
                    Pay period overtime
                  </div>
                  <div class="border-b"> </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">Start after
                        <input type="number" class="form-control" [(ngModel)]="generalObj.pay_period_overtime.value">
                        Hours/week</span>
                    </div>
                  </div>
                  <div class="d-flex gap-3">
                    <div for="requiresApproval" class="description">
                      <span class="d-flex align-items-center gap-2">
                        {{ generalObj.pay_period_overtime.s_m == 1 ? 'Multiplier' : 'Additional' }}
                        <input type="number" class="form-control" [(ngModel)]="generalObj.pay_period_overtime.s_mv">
                        <mat-select [(ngModel)]="generalObj.pay_period_overtime.s_m" class="sel-w ms-2"
                          panelClass="sel-we">
                          <mat-option [value]="1" selected>X base wage</mat-option>
                          <mat-option [value]="2">+ base wage</mat-option>
                        </mat-select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <button mat-raised-button color="primary" class="auth-form-btn" type="submit"
            (click)="onSavePremiumTime()">{{"BUTTON.SAVE" | translate
            }}</button>
        </div>

        <div *ngIf="selectedSetting.id== 5">
          <h4 class="mb-4">DressCode</h4>

          <div class="d-flex justify-content-between  user-b flex-wrap">
            <!-- <div class="search-cont gap-3">
              <div class="s-in form-input m-0" style="position: relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="{{ 'COMMON.SEARCH' | translate }}" class="form-control"
                  [(ngModel)]="filterObjData.dresscode.sh" (input)="onSearchMult($event, 'dress')"
                  (keyup.enter)="onGo('dress')" />
              </div>
              <div class="go-b m-0" (click)="onGo('today')">
                {{ "COMMON.GO" | translate }}
              </div>
            </div> -->
            <button mat-raised-button color="primary" class="primary-btn ms-auto mb-sm-2 mb-md-0" type="submit"
              (click)="onAddEditDress('','')"><i class="fas fa-plus"></i> Add New </button>
          </div>
          <div class="table-container mt-4 flex-grow-1 ">
            <table class="" mat-table [dataSource]="dressCode" class="mat-elevation-z8">
              <!-- <table class="" mat-table [dataSource]="dataSource" 
                          class="mat-elevation-z8"  *ngIf="dataSource.data.length!=0"> -->
              <ng-container matColumnDef="dress">
                <th mat-header-cell *matHeaderCellDef class="w-100">
                  {{"Dress Code"|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.dr_c }} </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <!-- <div class="action-btn me-2" matTooltip="View" (click)="onViewCompanyRates()">
                      <img src="assets/images/icons/view_icon.svg" class="img-fluid" alt="">
                    </div> -->
                    <div class="action-btn me-2" matTooltip="Edit" (click)="onAddEditDress('edit',element)">
                      <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-btn  cursor-pointer" matTooltip="Delete" (click)="onDeleteLogo(element.id)">
                      <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedDressColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedDressColumns;"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dressCode.data.length==0">
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
          </div>
          <div class="pagination-cont" *ngIf="dressCode?.data?.length != 0">
            <div class="show-item">
              {{ "COMMON.SIP" | translate }}
              <select class="form-control sel-op ms-2" (change)="onPageSizeChangeMult($event, 'dress')"
                [(ngModel)]="filterObjData.dresscode.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions">
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="page-c">
              <ngb-pagination [collectionSize]="filterObjData.dresscode.count"
                [(page)]="filterObjData.dresscode.currentPage" [pageSize]="filterObjData.dresscode.itemsPerPage"
                [maxSize]="filterObjData.dresscode.maxPaginationSize"
                (pageChange)="onPageChangeMult($event, 'dress')"></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>